import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { useFormStepper } from '@1trading/react/components/ui/form-stepper';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import { BINARY_ANSWERS } from '@/constants/answers';
import type { AmlQuestionnairePep } from '@/features/onboarding/aml-questionnaire/schema';

const AmlQuestionnaireFieldsetPepLegend = () => {
  const { t } = useTranslation();

  return (
    <PageHeading asChild>
      <legend>
        <PageHeadingTitle>{t('AMLQuestionnaire.pep.title')}</PageHeadingTitle>
        <PageHeadingDescription>{t('AMLQuestionnaire.pep.description')}</PageHeadingDescription>
      </legend>
    </PageHeading>
  );
};
AmlQuestionnaireFieldsetPepLegend.displayName = 'AmlQuestionnaireFieldsetPepLegend';

const AmlQuestionnaireFieldsetPep = () => {
  const form = useFormContext<AmlQuestionnairePep>();
  const { nextStepDeferred } = useFormStepper();
  const { t } = useTranslation();

  return (
    <FormField
      name="pep"
      control={form.control}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="sr-only">{t('AMLQuestionnaire.pep.title')}</FormLabel>
          <FormControl>
            <RadioGroup
              className="!mt-0"
              defaultValue={field.value}
              variant="cards"
              aria-label={t('AMLQuestionnaire.pep.title')}
              onValueChange={(value) => {
                field.onChange(value);
                nextStepDeferred();
              }}
            >
              {BINARY_ANSWERS.map((answer) => (
                <FormItem key={answer}>
                  <RadioGroupItemCard variant="outline">
                    <FormControl>
                      <RadioGroupItem value={answer} />
                    </FormControl>
                    <FormLabel contained onClick={() => nextStepDeferred()}>
                      {t(`fundamentals.${answer.toLowerCase()}`)}
                    </FormLabel>
                  </RadioGroupItemCard>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
AmlQuestionnaireFieldsetPep.displayName = 'AmlQuestionnaireFieldsetPep';
AmlQuestionnaireFieldsetPep.isAutoNextStep = true;

export { AmlQuestionnaireFieldsetPep, AmlQuestionnaireFieldsetPepLegend };
